var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('VueSlickCarousel',{attrs:{"arrows":true,"dots":true}},[_c('div',[_vm._v("1")]),_vm._v(" "),_c('div',[_vm._v("2")]),_vm._v(" "),_c('div',[_vm._v("3")]),_vm._v(" "),_c('div',[_vm._v("4")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }